import React from 'react';
import { Redirect } from 'react-router-dom';
import { useLocation } from 'react-router';
import { History } from 'history';

const MaybeRedirect: React.FC<{
  to: History.LocationDescriptor<History.LocationDescriptor>;
  keepSearchParams?: boolean;
  children?: React.ReactNode;
}> = ({ to, keepSearchParams, children }) => {
  const location = useLocation();
  if (to && to !== location.pathname) {
    return <Redirect to={`${to}${keepSearchParams ? location.search : ''}`} />;
  }
  // Else, show the app
  else {
    return <>{children}</>;
  }
};
export default MaybeRedirect;
